// app/courses/driving.tsx
import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';

export default function DrivingPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורסי נהיגה והוראת נהיגה',
        metaTitle: 'קורסי נהיגה 2025 – מורה נהיגה, נהיגה מסחרית | Kursi',
        slug: 'driving',
        metaDescription: 'קורסי נהיגה ישראל 2025 – הכשרת מורי נהיגה, נהיגה מסחרית, אוטובוס, משאית. מוכר משרד התחבורה. מדריך לבחירת הקורס הנכון עם צ׳ק-ליסט.',
        subtitle: 'הוראת נהיגה, נהיגה מסחרית ורכב ציבורי — קורסים מוסדרים לכל סוגי הרישיונות.',
        chips: ['מורה נהיגה', 'רישיון B', 'רכב ציבורי', 'משא כבד', 'אוטובוס', 'בוחן נהיגה'],
        chatSeed: 'קורס הוראת נהיגה',
        sections: [
          {
            id: 'types',
            title: 'סוגי קורסי נהיגה מקצועיים',
            body: 'נהיגה מקצועית כוללת מסלולים שונים. חשוב לבחור את הסוג הנכון לפי הרישיון שרוצים להשיג.',
            bullets: [
              'הוראת נהיגה: רישיון מורה נהיגה (רישיון 04)',
              'נהיגה מסחרית: אוטובוס, מונית, ואן',
              'משא כבד: משאיות ורכב כבד (רישיון C)',
              'בוחן נהיגה: תפקיד מטעם משרד התחבורה',
              'נהיגה בטוחה: קורסי רענון ושיפור',
            ],
          },
          {
            id: 'license',
            title: 'רגולציה ורישוי — מה חייבים לדעת',
            body: 'כל קורס נהיגה מקצועי בישראל מוסדר על ידי משרד התחבורה. ללא הכרה רשמית — הקורס לא שווה כסף.',
            bullets: [
              'ודאו שהקורס מוכר ע"י משרד התחבורה',
              'בדקו מה הדרישות לקבלה לקורס (גיל, רישיון קיים)',
              'שאלו על שיעור ההצלחה בבחינות הגמר',
              'ברורו אם יש תמיכה בהכנה לבחינה תיאורטית',
            ],
          },
          {
            id: 'practical',
            title: 'שעות מעשיות — הלב של הקורס',
            body: 'קורס נהיגה מקצועי חייב לכלול שעות נהיגה מעשיות על כביש אמיתי. קורס אונליין בלבד לא מספיק.',
            bullets: [
              'מינימום שעות נהיגה מעשיות (לפי משרד התחבורה)',
              'נהיגה בתנאים שונים: עיר, כביש מהיר, לילה',
              'מגוון כלי רכב בהתאם לרישיון המבוקש',
              'הדרכה פרטנית עם מורה נהיגה מוסמך',
            ],
          },
        ],
        checklist: [
          'הקורס מוכר על ידי משרד התחבורה',
          'יש שעות נהיגה מעשיות על כביש',
          'ברור מה הדרישות הקדם להצטרפות',
          'שיעור הצלחה גבוה בבחינות הגמר',
          'יש תמיכה בהכנה לבחינה תיאורטית',
        ],
        redFlags: [
          'קורס לא מוכר על ידי משרד התחבורה',
          'אין שעות נהיגה מעשיות',
          'הבטחות "רישיון מובטח" ללא בחינה',
          'אין בחינת גמר רשמית',
        ],
        faq: [
          {
            q: 'כמה עולה קורס הוראת נהיגה?',
            a: 'קורס מורה נהיגה בישראל עולה בדרך כלל 8,000–18,000₪ תלוי במוסד ובמסלול.',
          },
          {
            q: 'כמה זמן לוקח קורס מורה נהיגה?',
            a: 'בדרך כלל 6–12 חודשים. כולל לימוד תיאורטי, שעות נהיגה מעשיות ובחינות משרד התחבורה.',
          },
          {
            q: 'כמה מרוויח מורה נהיגה?',
            a: 'מורה נהיגה עצמאי מרוויח 12,000–30,000₪ לחודש תלוי בכמות השיעורים ובמיקום.',
          },
          {
            q: 'האם אפשר ללמוד הוראת נהיגה אונליין?',
            a: 'החלק התיאורטי אפשר אונליין, אבל שעות הנהיגה המעשיות חייבות להיות פיזיות. אי אפשר לעבוד כמורה נהיגה ללא הכשרה מעשית.',
          },
        ],
      }}
    />
  );
}
